import {find, get} from 'lodash'
import {RegionalLocale} from 'helpers/settings'
import {getUser, getUserSettings} from 'selectors/auth'

export const getActivityThreadPrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'ACTIVITY_THREAD'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getActivityThreadPrefixValue = state =>
  get(getActivityThreadPrefix(state), 'value', null)

export const getNewOpportunityPrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'OPPORTUNITY'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewOpportunityPrefixValue = state =>
  get(getNewOpportunityPrefix(state), 'value', null)

export const getNewAccountQuotePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'QUOTATION'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewAccountQuotePrefixValue = state =>
  get(getNewAccountQuotePrefix(state), 'value', null)

export const getNewAccountApprovalPrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'APPROVAL'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewAccountApprovalPrefixValue = state =>
  get(getNewAccountApprovalPrefix(state), 'value', null)

export const getNewUserQuotePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'QUOTATION'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) !== null
    && get(u, 'contactId', null) === getUser(state).contactId
    && !getUser(state).proSync)

export const getNewUserQuotePrefixValue = state =>
  get(getNewUserQuotePrefix(state), 'value', null)

export const getNewPartCodePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'PART_CODE'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewPartCodePrefixValue = state =>
  get(getNewPartCodePrefix(state), 'value', null)

export const getNewInvoicePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'INVOICE'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewInvoicePrefixValue = state =>
  get(getNewInvoicePrefix(state), 'value', null)

export const getNewCreditNotePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'CREDIT_NOTE'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewCreditNotePrefixValue = state =>
  get(getNewCreditNotePrefix(state), 'value', null)

export const getNewDeliveryNoteCodePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'DELIVERY_NOTE'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewDeliveryNotePrefixValue = state =>
  get(getNewDeliveryNoteCodePrefix(state), 'value', null)

export const getNewReturnNoteCodePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'RETURN_NOTE'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewReturnNotePrefixValue = state =>
  get(getNewReturnNoteCodePrefix(state), 'value', null)

export const getNewPurchaseOrderCodePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'PURCHASE_ORDER'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewPurchaseOrderPrefixValue = state =>
  get(getNewPurchaseOrderCodePrefix(state), 'value', null)

export const getNewUserPurchaseOrderPrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'PURCHASE_ORDER'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) !== null
    && get(u, 'contactId', null) === getUser(state).contactId
    && !getUser(state).proSync)

export const getNewUserPurchaseOrderPrefixValue = state =>
  get(getNewUserPurchaseOrderPrefix(state), 'value', null)

export const getNewPurchaseOrderInvoiceCodePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'PURCHASE_ORDER_INVOICE'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewPurchaseOrderInvoicePrefixValue = state =>
  get(getNewPurchaseOrderInvoiceCodePrefix(state), 'value', null)

export const getNewPurchaseOrderCreditNotePrefix = state =>
  find(state.settings.prefixes, u => get(u, 'type.value', '') === 'PURCHASE_ORDER_INVOICE_CREDIT_NOTE'
    && get(u, 'source', null) === null
    && get(u, 'contactId', null) === null)

export const getNewPurchaseOrderCreditNotePrefixValue = state =>
  get(getNewPurchaseOrderCreditNotePrefix(state), 'value', null)

export const getPricingAccuracy = state => state.auth.user.settings.pricingAccuracy || 2

export const getInvoiceFinancialYearStart = state => {
  return get(state, 'auth.user.settings.invoiceFinancialYearStart', 1) || 1
}

export const getContactLicences = state => {
  const contactLicences = get(state, 'settingsContext.contacts', [])
  return Object.values(contactLicences)
}

export const getExpandedTeamIds = state => state.settingsContext.teams.expandedTeamIds || []

export const getRegionalLocale = state => state.settings.locale

export const getRegionalDateFormat = state => state.settings.dateFormat

export const getRegionalTimeFormat = state => state.settings.timeFormat

export const getProductionCompleteName = state => get(getUserSettings(state), 'productionCompleteName', 'Goods Out')

export const isProductionDisabled = state => getUserSettings(state).productionDisabled

export const getRegionalLocaleTaxTerm = (state) => {
  const regionalLocale = getRegionalLocale(state)
  return regionalLocale === RegionalLocale.EN_GB
    ? 'VAT'
    : 'Tax'
}

export const getRegionalLocaleRRPTerm = (state) => {
  const regionalLocale = getRegionalLocale(state)
  return regionalLocale === RegionalLocale.EN_GB
    ? 'RRP'
    : 'MSRP'
}

export const getDefaultSalesNominalCode = state => state.auth.user.settings.salesNominalCode

export const getDefaultPurchaseNominalCode = state => state.auth.user.settings.purchaseNominalCode

export const getCurrencyPrecision = state => state.settings.currencyPrecision || 2

export const getContacts = state => state.settingsContext.contacts
export const getAllContacts = state => Object.values(state.settingsContext.contacts)

export const getAllRoles = state => Object.values(state.settingsContext.roles)

export const getMasterContact = state => {
  const contacts = getAllContacts(state) || []
  return contacts.find(contact => contact.level === 1)
}

export const getDefaultPaymentTerms = (state) => state.auth.user.settings.paymentTerms

export const getInvoiceLetterHeader = (state) => state.auth.user.settings.invoiceLetterHeader
export const getInvoiceLetterFooter = (state) => state.auth.user.settings.invoiceLetterFooter
export const getInvoiceEmailSubject = (state) => state.auth.user.settings.invoiceEmailSubject
export const getInvoiceEmailBody = (state) => state.auth.user.settings.invoiceEmailBody

export const getCreditNoteLetterHeader = (state) => state.auth.user.settings.creditNoteLetterHeader
export const getCreditNoteLetterFooter = (state) => state.auth.user.settings.creditNoteLetterFooter
export const getCreditNoteEmailSubject = (state) => state.auth.user.settings.creditNoteEmailSubject
export const getCreditNoteEmailBody = (state) => state.auth.user.settings.creditNoteEmailBody

export const getDeliveryNoteEmailSubject = (state) => state.auth.user.settings.deliveryNoteEmailSubject
export const getDeliveryNoteEmailBody = (state) => state.auth.user.settings.deliveryNoteEmailBody

export const getReturnNoteEmailSubject = (state) => state.auth.user.settings.returnNoteEmailSubject
export const getReturnNoteEmailBody = (state) => state.auth.user.settings.returnNoteEmailBody

export const getPurchasingUseManufacturerCode = (state) =>
  get(state, 'auth.user.settings.purchasingUseManufacturerCode', false)

export const getContactAddRequiredFields = state =>
  get(state, 'auth.user.settings.contactAddRequiredFields.required', [])
export const getPurchaseOrderRequiredFields = state =>
  get(state, 'auth.user.settings.purchaseOrderRequiredFields.required')

export const getApprovalsEmailSubject = state =>
  get(state, 'auth.user.settings.approvalsEmailSubject')
export const getApprovalsEmailBody = state =>
  get(state, 'auth.user.settings.approvalsEmailBody')

export const getApprovalCustomerLinkExpiry = state =>
  get(state, 'auth.user.settings.approvalsCustomerLinkExpiry')

export const getApprovalNotifyOwnerCustomerResponse = state =>
  get(state, 'auth.user.settings.approvalNotifyOwnerCustomerResponse')

export const getApprovalAllowCustomerFileDownload = state =>
  get(state, 'auth.user.settings.approvalAllowCustomerFileDownload')

export const getApprovalsTermsAndConditionsSetting = state =>
  get(state, 'auth.user.settings.approvalsTermsAndConditions')

export const getApprovalsAutomaticallySendRemindersForResponseSetting = state =>
  get(state, 'auth.user.settings.approvalAutomaticallySendRemindersForResponse')

export const getAuthUserSettings = state => get(state, 'settings.authUserSettings')

export const getAuthSettings = state => get(state, 'settings.authSettings')

export const getApprovalsAutomaticRemindersEmailSubject = state =>
  get(state, 'auth.user.settings.approvalsAutomaticRemindersEmailSubject')
export const getApprovalsAutomaticRemindersEmailBody = state =>
  get(state, 'auth.user.settings.approvalsAutomaticRemindersEmailBody')
export const getApprovalsAutomaticRemindersEmailFrom = state =>
  get(state, 'auth.user.settings.approvalsAutomaticRemindersEmailFrom')
export const getApprovalsAutomaticRemindersEmailReplyTo = state =>
  get(state, 'auth.user.settings.approvalsAutomaticRemindersEmailReplyTo')

export const getQuotingAutomaticRemindersEmailSubject = state =>
  get(state, 'auth.user.settings.quotingAutomaticRemindersEmailSubject')
export const getQuotingAutomaticRemindersEmailBody = state =>
  get(state, 'auth.user.settings.quotingAutomaticRemindersEmailBody')
export const getQuotingAutomaticRemindersEmailFrom = state =>
  get(state, 'auth.user.settings.quotingAutomaticRemindersEmailFrom')
export const getQuotingAutomaticRemindersEmailReplyTo = state =>
  get(state, 'auth.user.settings.quotingAutomaticRemindersEmailReplyTo')